export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROLE_MERCHANT = 'ROLE_MERCHANT';
export const ROLE_LOCAL_MERCHANT = 'ROLE_LOCAL_MERCHANT';
export const ROLE_CONSUMER = 'ROLE_CONSUMER';
export const ROLE_CASHIER = 'ROLE_CASHIER';
